import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M12 1a11 11 0 0 1 3.705.643l.505.194a11 11 0 0 1 3.177 2.012l.391.373a11 11 0 0 1 2.165 3.074l.22.494a11 11 0 0 1 .194 7.915l-.194.505a11 11 0 0 1-5.459 5.733l-.494.22a11 11 0 0 1-7.915.194l-.505-.194a11 11 0 0 1-5.733-5.459l-.22-.494a11 11 0 0 1-.194-7.915l.194-.505a11 11 0 0 1 5.459-5.733l.494-.22A11 11 0 0 1 12 1Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#054696",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M12 1A11 11 0 1 1 1 12"
    }, null, -1)
  ])))
}
export default { render: render }